// extracted by mini-css-extract-plugin
export default {"box":"models-page-body_box__+NiP9","list":"models-page-body_list__dis3d"};